export default "./dist/stdassets/images/icons/icon_menuarrowup.png";